import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddExtraRecordsForm from './AddExtraRecordsForm.jsx';
//  import useLookupModule from '../../../../hooks/Lookups/use-Lookup-Module.js';
import { Card, CardBody } from '../../../../components/card/card.jsx';
import ModalComponent from '../../../../components/Modal/ModalComponent.jsx';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import useGetDynamicForm from '../../../../hooks/Forms/useGetDynamicForm.js';
// import Loader from '../../../../components/Shared/Loader/Loader.js';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';
import EditExtraRecordsForm from './EditExtraRecordsForm.jsx';

const ExtraRecordsForm = () => {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('');
  const Navigate = useNavigate();
  const [item, setItem] = useState(null);

  const [selectedValue, setSelectedValue] = useState('');
  // const { Module } = useLookupModule();
  //__________________________________________________

  const { DynamicExtraRecord, loading } = useGetDynamicForm();

  //_________________________________________________________________________________________________

  const filtered = DynamicExtraRecord?.slice()
    ?.filter((item) => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.name?.toLowerCase().includes(searchLowerCase) ||
        item.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter((f) => (selectedValue === '' ? true : f.moduleId === selectedValue));

  //________________________________
  const columns = [
    { title: t('Name'), key: 'Name', className: 'w-25' },
    { title: t('Application'), key: 'Application', className: 'w-25' },
    { title: t('Table'), key: 'Table', className: 'w-25' },
    { title: t('Icon'), key: 'Icon', className: 'w-25' },
    { title: t(''), key: 'action', className: 'text-end w-25' },
  ];

  const tableData = filtered?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      Application: i18n.language === 'ar' ? item.moduleName2 : item.moduleName,
      Table: i18n.language === 'ar' ? item.tableName2 : item.tableName,
      Icon: (
        <div className="text-theme">
          <i className={item.icon}></i>
        </div>
      ),
      action: (
        <div className="btn-group">
          {HasPermission('NtxAddingfieldstoExtraInformationRecordform') && (
            <button
              type="button"
              onClick={() => Navigate(`/NTX/Forms/${item.id}/AddFormColumns/3`)}
              className="btn btn-sm btn-outline-theme"
              data-toggle="tooltip"
              title={t('fieldsForm')}>
              <i className="fab fa-lg fa-fw fa-elementor ms-1"></i>
              {t('fieldsForm')}
            </button>
          )}

          {HasPermission('NtxEditExtraInformationRecordform') && (
            <button
              type="button"
              // onClick={() => Navigate(`${item.id}/EditExtraRecordsForm`)}
              className="btn btn-sm btn-outline-theme"
              data-toggle="tooltip"
              onClick={() => setItem(item)}
              data-bs-toggle="modal"
              data-bs-target="#modalEditForm"
              title={t('Button.Edit')}>
              <i className="far fa-lg fa-fw fa-edit me-1"></i>
              {t('Button.Edit')}
            </button>
          )}
        </div>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });
  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: t('ExtraRecordForm'),
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('ExtraRecordForm')} />
        <div className="ms-auto">
          {HasPermission('NtxAddExtraInformationRecordform') && (
            <Link
              to=""
              className="btn btn-theme"
              data-bs-toggle="modal"
              data-bs-target="#modalAddForm"
              // hidden={hiddenAddForm}
            >
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('AddForm')}
            </Link>
          )}
        </div>
      </div>

      <Card>
        <Loading loading={loading}>
          <CardBody>
            {/* <div className="row mb-3">
            <div className="col-7 col-md-6 d-flex justify-content-start">
              <div className="input-group mb-2">
                <div className="flex-fill position-relative">
                  <div className="input-group ">
                    <select
                      className="btn btn-outline-default dropdown-toggle p-0"
                      value={selectedValue}
                      onChange={(e) => setSelectedValue(e.target.value)}>
                      <option className="dropdown-item" value={''}>
                        {t('All')}
                      </option>
                      {Module &&
                        Module?.map((item) => (
                          <option value={item.id} key={item.id} className="dropdown-item">
                            {i18n.language === 'ar' ? item.name2 : item.name}
                          </option>
                        ))}
                    </select>

                    <div className="flex-fill position-relative">
                      <div className="input-group">
                        <div
                          className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                           >
                          <i className="fa fa-search opacity-5"></i>
                        </div>
                        <input
                          type="text"
                          autoComplete="off"
                          className="form-control ps-35px"
                          placeholder={t('Search')}
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddExtraRecordForm')} id="modalAddForm" size="lg">
        <AddExtraRecordsForm />
      </ModalComponent>

      <ModalComponent title={t('EditForm')} id="modalEditForm" size="lg">
        {item && <EditExtraRecordsForm id={item.id} />}
      </ModalComponent>
    </>
  );
};

export default ExtraRecordsForm;
